import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';

import { CenterInfo } from '@models/center/info/center-info';
import { SessionService } from '../session.service';

@Injectable({
    providedIn: 'root'
})
export class PaymentAppService {
    constructor(private router: Router, private sessionService: SessionService) { }

    checkPayment(): Observable<boolean> {
        return new Observable<boolean>(
            observable => {
                const centerInfo: CenterInfo = this.sessionService.getCenterInfo();
                if (centerInfo === null || !centerInfo.isPayment) {
                    observable.next(true);
                } else {
                    this.router.navigate(['customer/wallet']);
                    observable.next(false);
                }
            }
        );
    }
}
